<label>
  <div
    class="form-field__label form-field__text-label"
    [class.form-field__label--error]="showError"
  >
    {{ field.label | translateInline }}
  </div>

  <div class="form-field__select-input-wrapper">
    <input
      #input
      [ngModel]="selectState.typeAheadValue()"
      (ngModelChange)="onTypeAheadValueChange($event)"
      placeholder="{{ field.label | translateInline }}"
      [readonly]="selectState.typeAheadReadonly()"
      class="form-field__input form-field__text-input form-field__select-input"
      [class.form-field__input--error]="showError"
      [class.form-field__text-input--disabled]="isReadonly"
      (focus)="onInputFocus($event, input)"
      (blur)="onInputBlur()"
      (contextmenu)="onContextMenu($event)"
      autocomplete="off"
    />

    <div
      class="form-field__select-input-icon form-field__select-input-icon--pull-right"
      [class.form-field__select-input-icon--focused]="
        selectState.dropdownShown()
      "
      [class.form-field__select-input-icon--error]="showError"
      [class.form-field__select-input-icon--disabled]="isReadonly"
    >
      <fa-icon [icon]="_iconOpen"></fa-icon>
    </div>
  </div>

  <div class="form-field__select-dropdown-wrapper">
    <ul
      #list
      class="form-field__select-dropdown"
      [class.form-field__select-dropdown--focused]="selectState.dropdownShown()"
      (mouseout)="onListMouseOut()"
      (mouseenter)="onListMouseEnter()"
    >
      @for (option of filteredItems(); track option.value; let i = $index) {
        <li
          class="form-field__select-dropdown-item form-field__select-dropdown-item--selectable"
          [class.form-field__select-dropdown-item--selected]="
            option.value === _value
          "
          [class.form-field__select-dropdown-item--focused]="
            i === selectState.cursorIndex()
          "
          (mousedown)="onListItemMouseDown(option, $event)"
          (touchstart)="onListItemTouchStart(option, $event)"
          (mouseup)="onListItemMouseUp(option, $event)"
          (touchend)="onListItemTouchEnd(option, $event)"
          (click)="onListItemClicked(option, $event)"
        >
          {{ option.label | translateInline }}
        </li>
      } @empty {
        <li
          class="form-field__select-dropdown-item form-field__select-dropdown-item--hint"
        >
          {{ notFoundError }}
        </li>
      }
    </ul>
  </div>

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      <div>
        {{ control.errors | declarativeErrorMessage: field : declaration }}
      </div>
    }
  </div>
</label>
